import React from "react";
import { ColumnProps, RowDataType } from "rsuite-table";

import Parking from "../../../../../../services/Parking2";
import LightTable from "../../../../../LightTable";
import { TranslationText } from "../../../../../common";

import columns, { ColumnId } from ".";

function base(
	columnId: ColumnId,
	render: base.Render,
	column: Partial<ColumnProps<RowDataType>> & { fullText?: boolean } = {},
) {
	const { fullText = true, ...columnProps } = column;

	return (
		<LightTable.Column key={columnId} resizable sortable {...columnProps}>
			<LightTable.HeaderCell>
				<TranslationText text={columns[columnId].label} />
			</LightTable.HeaderCell>
			<LightTable.Cell dataKey={columnId} fullText={fullText}>
				{(rowData) => render(rowData as Parking.Model)}
			</LightTable.Cell>
		</LightTable.Column>
	);
}

declare namespace base {
	type Render = (item: Parking.Model) => React.ReactNode;
}

export default base;
